import { createContext } from 'react';

export const ServiceContext = createContext({
  service: null,
});
